<template>
    <div>
        <v-btn-toggle v-model="selectCategoryBtn" class="category" multiple @change="filterCourse">
            <v-btn flat class="flex1" value="3">
                <i class="iconfont icon-ziyuan pr-1"></i>物质
            </v-btn>
            <v-btn flat class="flex1" value="0">
                <i class="iconfont icon-fangxing pr-1"></i>身
            </v-btn>
            <v-btn flat class="flex1" value="1">
                <i class="iconfont icon-kongxinsanjiao pr-1"></i>心
            </v-btn>
            <v-btn flat class="flex1" value="2">
                <i class="iconfont icon-lingxing pr-1"></i>灵
            </v-btn>
        </v-btn-toggle>
        <v-select :items="coachList" label="按导师查找" solo multiple v-model="selectedCoach" clearable item-value="id"
                  item-avatar="avatar" item-text="name">
            <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                    <v-avatar>
                        <img :src="item.avatar" alt="">
                    </v-avatar>
                    <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">和其他{{ selectedCoach.length - 1 }}位导师</span>
            </template>
        </v-select>
        <div v-if="!shownCourses.length">
            <p class="pt-4 text-center">当前所选分类下还未更新内容，敬请期待～</p>
        </div>
        <v-container fluid>
            <v-card class="course" v-for="c in shownCourses">
                <v-img class="white--text" min-height="200px" :src="c.cover" color="gray">
                    <v-container fill-height fluid>
                        <v-layout column>
                            <v-flex align-end flexbox>
                                <span class="headline font-weight-bold">{{ c.title }}</span>
                            </v-flex>
                            <v-chip color="secondary challenges" text-color="white">
                                <v-avatar class="secondary darken-2">{{ c.missionSum }}</v-avatar>
                                天挑战
                            </v-chip>
                        </v-layout>
                    </v-container>
                </v-img>
                <v-card-title class="pb-0">
                    <div class="subheading pb-2">{{ c.subtitle }}</div>
                </v-card-title>
                <v-card-text>
                    <div style="display: flex; flex-direction: row; justify-content: space-between">
                        <v-chip class="white ma-0">
                            <v-avatar class="gray lighten-2">
                                <img :src="c.coach.avatar" alt="" v-if="c.coach.avatar">
                            </v-avatar>
                            {{ c.coach.name }}
                        </v-chip>
                        <div class="grey--text pt-2">{{c.joinNum || 0}} 人正在挑战</div>
                    </div>
                    <div style="display: flex; justify-content: space-between">
                        <div class="pt-3"><i class="iconfont icon-shan pr-1"></i>完成挑战：{{ c.missionDone
                            }}/{{ c.missionSum }}
                        </div>
                        <div class="pt-3"><i class="iconfont icon-jifen pr-1"></i>获得积分：{{ c.scoreGot
                            }}/{{ c.scoreSum }}
                        </div>
                    </div>
                    <div style="display: flex; align-items: center" class="mt-3" v-if="c.price > 0">
                        <v-chip style="font-size: 16px"
                                class="ma-0 mr-2"
                                color="price"
                                label
                                text-color="white"
                                v-if="c.onSale"
                        >
                            <i class="iconfont icon-xianshi1 pr-1"></i>限时
                        </v-chip>
                        <div class="price--text price-font">￥{{c.price}}</div>
                        <div style="text-decoration: line-through;" class="grey--text pl-2" v-if="c.onSale">￥{{c.originalPrice}}</div>
                    </div>
                    <div v-else class="mt-3">
                        <v-chip style="font-size: 16px"
                                class="ma-0 mr-2"
                                color="primary"
                                label
                                text-color="white"
                        >
                            全免费
                        </v-chip>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" block @click="enterCourse(c.id)">进入挑战</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {getCourses, getCoachList} from '@/api/mission'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        data() {
            return {
                courses: [],
                selectedCoach: [],
                selectCategoryBtn: [],
            }
        },
        mounted() {
            this.filterCourse()
        },
        computed: {
            selectedCategory() {
                return this.selectCategoryBtn.join(',')
            },
            coachList() {
                return this.courses.map(e => {
                    return e.coach
                })
            },
            shownCourses() {
                return this.courses.filter(e => {
                    return this.selectedCoach.length === 0 || this.selectedCoach.indexOf(e.coach.id) > -1
                })
            }
        },
        methods: {
            ...mapActions([
                'HideLoading',
                'HideSmLoading',
                'ShowSmLoading'
            ]),
            enterCourse(cid) {
                this.$router.push({name: 'missionList', params: {cid: cid}})
            },
            filterCourse() {
                this.ShowSmLoading()
                getCourses(this.selectedCategory).then(res => {
                    this.courses = res
                    this.HideLoading()
                    this.HideSmLoading()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course {
        margin-bottom: 20px;

        .challenges {
            position: absolute;
            right: 10px;
            bottom: 10px;
        }
    }

    .title {
        margin-bottom: 15px;
    }

    .category {
        width: 100%;

        .flex1 {
            flex: 1;
            font-size: 14px;
            height: 40px;
            border: 1px solid #eee;

            &.v-btn--active {
                background: #14b5b1;
                color: #fff;
                border: 1px solid #fff;
            }
        }

    }

    .text-center {
        text-align: center;
    }

    .price-font {
        font-size: 24px;
        font-weight: bold;
    }
</style>
